<h2 class="m-b-5" mat-dialog-title>{{templateTitle}}</h2>

<div mat-dialog-content id="baja-edit-card">
    <form class="add-document-form" [formGroup]="templateFormGroup" role="form" autocomplete="off">

        <mat-form-field floatLabel="always">
            <input matInput placeholder="Nombre" formControlName="nombre" />
        </mat-form-field>
        <mat-error
            *ngIf="(templateFormGroup.get('nombre').dirty || templateFormGroup.get('nombre').touched ) && templateFormGroup.get('nombre').invalid">
            <span *ngIf="templateFormGroup.get('nombre').errors.required" class="validation-span ">Obligatorio</span>
        </mat-error>


        <div class="uploadfilecontainer" (click)="fileInput.click()" appDragAndDrop
             (OnFileDropped)="uploadFile($event)">
            <!-- Currently Supports only .docx files -->
            <!--<input hidden type="file" #fileInput (change)="uploadFile($event.target.files)" accept=".docx">-->
            <input hidden type="file" #fileInput (change)="uploadFile($event.target.files)" accept="{{FileFormatEnum.CitationController}}">
            <input hidden type="text" formControlName="path">
            <input hidden type="text" formControlName="documentInBase64">
            <mat-icon class="f-s-19 upload_icon">cloud_upload</mat-icon>
        </div>

        <mat-error
            *ngIf="(templateFormGroup.get('documentInBase64').dirty || templateFormGroup.get('documentInBase64').touched ) && templateFormGroup.get('documentInBase64').invalid">
            <span *ngIf="templateFormGroup.get('documentInBase64').errors.required"
                class="validation-span ">Obligatorio</span>
        </mat-error>

    </form>
</div>
<mat-progress-bar class="m-t-5 m-b-5" mode="indeterminate" *ngIf="IsSaving"></mat-progress-bar>
<div class="text-a-r p-t-5">
    <button class="m-r-15" mat-raised-button color="accent" (click)="addDocument()">Guardar</button>
    <button mat-raised-button color="warn" (click)="cancel()">Cancelar</button>
</div>